import { type HighlightProps, Highlight } from './Highlight/Highlight'
import { StyledContainer } from './Highlights.Styled'

export type HighlightsProps = {
  highlights: HighlightProps[]
}

export const Highlights = ({ highlights }: HighlightsProps) => {
  return (
    <StyledContainer>
      {highlights.map(({ icon, subtitle, title }) => (
        <Highlight key={title} icon={icon} subtitle={subtitle} title={title} />
      ))}
    </StyledContainer>
  )
}
